import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LinkableAccount } from '../../_models/fundraising/LinkableAccount';
import { FundraiserListView } from '../../_models/fundraising/Fundraiser';
import { Cue5050Site } from '../../_models/fundraising/Cue5050Site';
import { getUrl } from '../../_shared/utils';
import { JWTTokenService } from '../jwtToken.service';
import { BaseService } from '../../_shared/base.service';

export abstract class FundraisingService extends BaseService {

  public apiUrl = getUrl();

  constructor(
    protected eventType: string,
    protected http: HttpClient,
    protected jwtTokenService: JWTTokenService) { 
      super(http, jwtTokenService)
    }

    public getAll(): Observable<FundraiserListView> {
        return this.CachedHttpGet<FundraiserListView>('fundraising/events');
    }

    public getLinkedMerchants(): Observable<LinkableAccount[]> {
      return this.http.get<LinkableAccount[]>(getUrl(`fundraising/linked-merchants`), this.requestOptionsAuthenticated('portal'));
    }

    public startEvent(id: number): Observable<void> {
      this.InvalidateCache(/^fundraising*/)
      return this.http.get<void>(getUrl(`fundraising/event/start/${id}`), this.requestOptionsAuthenticated('portal'));
    }

    public completeEvent(id: number): Observable<void> {
      this.InvalidateCache(/^fundraising*/)
      return this.http.get<void>(getUrl(`fundraising/${this.eventType}/complete/${id}`), this.requestOptionsAuthenticated('portal'));
    }

    public cancelEvent(id: number): Observable<void> {
      this.InvalidateCache(/^fundraising*/)
      return this.http.get<void>(getUrl(`fundraising/event/cancel/${id}`), this.requestOptionsAuthenticated('portal'));
    }
 
    protected requestOptionsAuthenticated(tokenKey: string) {
        const requestOptions = {
            headers: new HttpHeaders()
                .set('Content-type', 'application/json')
                .append('Authorization', 'Bearer ' + this.jwtTokenService.getToken(tokenKey)),
        };
        return requestOptions;
    }

  }